import React from 'react'
import { Row, Col } from 'react-bootstrap'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_AdviserProfileInvestmentMinimums.scss'
import * as commonStyles from '../../../common/_common.scss'
import { formatToRands } from '../../formatters'
import PropTypes from 'prop-types';

class AdviserProfileInvestmentMinimums extends React.Component {

  static propTypes = {
    investmentMinimums: PropTypes.object.isRequired,
    children: PropTypes.object,
    modifiedLumpSum: PropTypes.bool,
    modifiedDebitOrder: PropTypes.bool
  }

  localesMyAppSupports = [
    'en-ZA'
  ]

  render () {
    const minimumLumpSum = this.props.investmentMinimums ? this.props.investmentMinimums.minimumLumpSum : 0
    const minimumMonthlyDebitOrder = this.props.investmentMinimums ? this.props.investmentMinimums.minimumMonthlyDebitOrder : 0

    return (
      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <h4 className={styles['title']}>Investment minimums {this.props.children}</h4>
          <Row className={styles['minimum']}>
            <Col xs={12} sm={6} md={6} lg={6}>
              <h5 className={styles['margin-bottom']}>Minimum lump sum</h5>
              <p className={styles['bottom-element'] + ' ' + (this.props.modifiedLumpSum ? styles['field-was-modified'] : '')}>
                {formatToRands(minimumLumpSum)}
              </p>
            </Col>
            <Col xs={12} sm={6} md={6} lg={6} className={styles['group-element']}>
              <h5 className={styles['margin-bottom']}>Minimum monthly debit order</h5>
              <p className={styles['bottom-element'] + ' ' + (this.props.modifiedDebitOrder ? styles['field-was-modified'] : '')}>
                {formatToRands(minimumMonthlyDebitOrder)}
              </p>
            </Col>
          </Row>
        </Col>
      </Row>
    )
  }

}

export default (AdviserProfileInvestmentMinimums)

